import { getSampleEventsFromSoundFont } from "@ryohey/wavelet";
export class SoundFont {
    data;
    sampleEvents;
    constructor(data, sampleEvents) {
        this.data = data;
        this.sampleEvents = sampleEvents;
    }
    getDrumKitPresets() {
        const drumKitPresets = new Map(); // programNumber -> PresetMeta
        for (const eventWrapper of this.sampleEvents) {
            const event = eventWrapper.event;
            if (event.type === "sampleParameter") {
                const { parameter, range } = event;
                const programNumber = range.instrument; // GM patch number
                const keyStart = range.keyRange[0];
                const keyEnd = range.keyRange[1];
                // Check if this is a drum kit
                const isDrumKit = range.bank === 128;
                if (!isDrumKit) {
                    continue; // Skip non-drum kit presets
                }
                let preset = drumKitPresets.get(programNumber);
                // Create preset if it doesn't exist
                if (!preset) {
                    preset = {
                        name: `Drum Kit ${programNumber}`,
                        samples: new Map(),
                    };
                    drumKitPresets.set(programNumber, preset);
                }
                // Add sample metadata for each key in the range
                for (let key = keyStart; key <= keyEnd; key++) {
                    if (!preset.samples.has(key)) {
                        preset.samples.set(key, []);
                    }
                    const sampleMeta = {
                        name: parameter.name,
                    };
                    preset.samples.get(key)?.push(sampleMeta);
                }
            }
        }
        return drumKitPresets;
    }
    static async loadFromURL(url) {
        const response = await fetch(url);
        const data = await response.arrayBuffer();
        return await SoundFont.load(data);
    }
    static async load(data) {
        const sampleEvents = getSampleEventsFromSoundFont(new Uint8Array(data));
        return new SoundFont(data, sampleEvents);
    }
}
//# sourceMappingURL=SoundFont.js.map